// lightbox2 a richiesta: la usa solo la galleria degli articoli del blog.
// Si porta dietro anche una seconda copia di jQuery se si sbaglia variante,
// quindi si importa "lightbox2" e non "lightbox-plus-jquery".

let lightboxPromise = null;

window.loadLightbox = function () {
    if (!lightboxPromise) {
        lightboxPromise = Promise.all([
            import("lightbox2"),
            import("lightbox2/dist/css/lightbox.css"),
        ]).then(([module]) => {
            const lightbox = module.default ?? module;
            window.lightbox = lightbox;
            return lightbox;
        });
    }

    return lightboxPromise;
};
